'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker?.register('/sw.js', { scope: '/' })?.then((registration) => {
            console.log('[SW] Registered:', registration?.scope);
          })?.catch((err) => {
            console.warn('[SW] Registration failed:', err);
          });
      });
    }
  }, []);

  return null;
}
